import { render, staticRenderFns } from "./bufenKaiPiao.vue?vue&type=template&id=e9189506&scoped=true&"
import script from "./bufenKaiPiao.vue?vue&type=script&lang=js&"
export * from "./bufenKaiPiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9189506",
  null
  
)

export default component.exports